import {persistKey} from '../../../../redux/reducers/authReducer'
import {decodeToken} from 'react-jwt'
import {ApiResponse} from '../../../core/_core'
import {vw_application_user} from 'openapi'
import api from 'config/api'

export interface InitAuthState {
  authToken: string | undefined
  user: vw_application_user | undefined
  loading: boolean
  errorMessage: string | null
}

const IS_LOGIN_LOCAL_STORAGE_KEY = 'kt-is-login'
const USER_LOCAL_STORAGE_KEY = 'kt-user-key'
const PERSIST_LOCAL_STORAGE_KEY = `persist:${persistKey}`
const getToken = (): string | undefined => {
  if (!localStorage) {
    return
  }

  const fromPersist: any = localStorage.getItem(PERSIST_LOCAL_STORAGE_KEY)
  try {
    if (fromPersist) {
      const authState: InitAuthState = JSON.parse(fromPersist) as InitAuthState
      if (authState) {
        return authState.authToken
      }
    }
  } catch (error) {
    console.error('Get Token Error', error)
  }
  return undefined
}

const setIsAuthenticated = (value: boolean) => {
  if (!localStorage) return

  try {
    const isLogin = value ? '1' : '0'
    localStorage.setItem(IS_LOGIN_LOCAL_STORAGE_KEY, isLogin)
  } catch (error) {
    console.error('isAuthenticated Save Error', error)
  }
}

const isAuthenticated = () => {
  if (!localStorage) return

  try {
    const value: string | null = localStorage.getItem(IS_LOGIN_LOCAL_STORAGE_KEY)
    return value === '1' ? true : false
  } catch (error) {
    console.error('isAuthenticated Error', error)
  }
  return false
}

const claimToken = async (token: string) => {
  return new Promise(async (resolve, reject) => {
    var result: ApiResponse = {
      data: null,
      message: null,
    }

    if (!decodeToken(token)) {
      result.message = 'Token is invalid'
      resolve(result)
      return
    }

    try {
      result = (await api.user.getUserProfile()) as unknown as ApiResponse<vw_application_user>
      if (result.data) {
        storeUser(result.data)
      } else {
        reject()
      }
      resolve(result)
    } catch (error) {
      reject()
    }
  })
}

const storeUser = async (user: vw_application_user) => {
  if (!localStorage) return

  try {
    localStorage.setItem(USER_LOCAL_STORAGE_KEY, JSON.stringify(user))
  } catch (error) {
    console.error('USER SAVE ERROR', error)
  }
}

const getUser = (): vw_application_user | undefined => {
  try {
    const value: string | null | undefined = localStorage.getItem(USER_LOCAL_STORAGE_KEY)
    if (value === null || value === undefined) {
      logout()
      return undefined
    }
    var user: vw_application_user = JSON.parse(value)
    return user
  } catch (error) {
    logout()
    console.error('Logout Error', error)
  }
  return undefined
}
const logout = () => {
  if (!localStorage) {
    return
  }

  try {
    localStorage.removeItem(PERSIST_LOCAL_STORAGE_KEY)
    localStorage.removeItem(USER_LOCAL_STORAGE_KEY)
    localStorage.removeItem(IS_LOGIN_LOCAL_STORAGE_KEY)
  } catch (error) {
    console.error('Logout Error', error)
  }
}

// export function setupAxios(axios: any) {
//   axios.defaults.headers.Accept = 'application/json'
//   axios.interceptors.request.use(
//     (config: { headers: { Authorization: string } }) => {
//       const auth = getToken()
//       // if (auth && auth.api_token) {
//       //   config.headers.Authorization = `Bearer ${auth.api_token}`
//       // }

//       return config
//     },
//     (err: any) => Promise.reject(err)
//   )
// }

export {setIsAuthenticated, isAuthenticated, getToken, getUser, claimToken, logout, storeUser}
